// extracted by mini-css-extract-plugin
export var divider = "_1o-0";
export var dividerText = "_1o-2";
export var dividerVertical = "_1o-1";